module.exports = __webpack_public_path__ + "static/media/CarolinaSilva.891eddd2.png";